import { Pipe, PipeTransform } from '@angular/core';
import { ProductActionModel } from '@features/product/product-actions/product-actions';

@Pipe({
    name: 'productAvailable',
    standalone: true
})
export class ProductAvailablePipe implements PipeTransform {
    /**
     * Three properties decide if the product is available at all in either web or store,
     * this pipe is used to figure out what to display in the UI
     * @param stockQuantity.stockQuantity
     * @param stockQuantity - The current online stock quantity
     * @param reserveInStore - Product has reserve in store flag enabled in Encode
     * @param digitalProduct - Product is not a digital product
     * @param stockQuantity.reserveInStore
     * @param stockQuantity.digitalProduct
     * @returns boolean
     */
    transform({ stockQuantity, reserveInStore, digitalProduct }: ProductActionModel): boolean {
        return Boolean(stockQuantity > 1 || reserveInStore || digitalProduct);
    }
}
